import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { Observable } from 'rxjs';
import { EurPipe } from '@cl/shared/pipes/eur.pipe';
import { Payout } from '@cl/shared/models/payouts/payout.model';
import { PayoutFilter } from '@cl/shared/models/payouts/payout-filter.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PayoutsService extends BaseServiceWithFilter<Payout, PayoutFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/payouts/');
    }

    searchBetweenRevenuePayouts(text: string): Observable<CommandResult<Payout[]>> {
        return this.httpClient.get<CommandResult<Payout[]>>(`${this.baseApiUrl}search-between-revenue-payouts/${text}`);
    }

    toString(object: Payout): string {
        return `${object.orders.number} [${object.date}] ${new EurPipe().transform(object.revenueSumWithoutVat)}`;
    }

    async changePayoutOrder(payoutId: number, orderId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}change-order`, { payoutId, orderId }));
    }

    async changePayoutsOrder(payoutIds: number[], orderId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}change-order-bulk`, { payoutIds, orderId }));
    }
}
